$metaHeight: 48px;
$toolbarHeight: 72px;
$mainHeight: 68px;

$mobile-nav-width: 305px;
$mobile-nav-width-phone: 296px;

:host {
  display: block;

  *,
  :after,
  :before {
    box-sizing: border-box;
    outline: 0 none;
    text-rendering: optimizelegibility;
  }
}

@mixin animation {
  transition-property: all;
  transition-duration: 400ms;
  transition-timing-function: ease;
  transition-delay: 0s;
}

.#{$prefix}navigation-wrapper {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  outline: 0 none;
  text-rendering: optimizelegibility;
  margin: 0;
  padding: 0;
  font-family: $font-family-base;
  z-index: 99;
  box-shadow: $navigation-box-shadow;
  @include animation;

  &.#{$prefix}sticky {
    position: fixed;
    left: 0;
    top: 0;
  }

  &.#{$prefix}collapsed {
    top: ($metaHeight + $toolbarHeight + $mainHeight) * -1;

    // act as if no toolbar navigation (toolbar hidden on mobile)
    @include for-size(tablet-or-smaller) {
      top: ($metaHeight + $mainHeight) * -1;
    }

    // if no toolbar navigation
    &.#{$prefix}nav-meta-main {
      top: ($metaHeight + $mainHeight) * -1;
    }

    // if no meta navigation
    &.#{$prefix}nav-toolbar-main {
      top: ($toolbarHeight + $mainHeight) * -1;

      // act as if no toolbar navigation (toolbar hidden on mobile)
      @include for-size(tablet-or-smaller) {
        top: ($mainHeight) * -1;
      }
    }

    // if no meta and no toolbar navigation
    &.#{$prefix}nav-main {
      top: ($mainHeight) * -1;
    }

    .#{$prefix}mobile-wrapper {
      height: calc(100vh - var(--mobileNavigationPaddingSticky));
    }
  }

  &.#{$prefix}sticky-level-main {
    &.#{$prefix}collapsed {
      top: ($metaHeight + $toolbarHeight) * -1;

      // act as if no toolbar navigation (toolbar hidden on mobile)
      @include for-size(tablet-or-smaller) {
        top: ($metaHeight) * -1;
      }

      // if no toolbar navigation
      &.#{$prefix}nav-meta-main {
        top: ($metaHeight) * -1;
      }

      // if no meta navigation
      &.#{$prefix}nav-toolbar-main {
        top: ($toolbarHeight) * -1;

        // act as if no toolbar navigation (toolbar hidden on mobile)
        @include for-size(tablet-or-smaller) {
          top: 0;
        }
      }

      // if no meta and no toolbar navigation
      &.#{$prefix}nav-main {
        top: 0;
      }
    }
  }

  &.#{$prefix}sticky-level-toolbar {
    &.#{$prefix}collapsed {
      top: ($metaHeight) * -1;

      // if no meta navigation
      &.#{$prefix}nav-toolbar-main {
        top: 0;

        // act as if no toolbar navigation (toolbar hidden on mobile)
        @include for-size(tablet-or-smaller) {
          top: 0;
        }
      }

      // if no meta and no toolbar navigation
      &.#{$prefix}nav-main {
        top: 0;
      }
    }
  }

  &.#{$prefix}sticky-level-meta {
    &.#{$prefix}collapsed {
      top: 0;
    }
  }

  .#{$prefix}toolbar-sub {
    position: relative;
    width: 100%;
    height: 0px;
    max-height: 70vh;
    background-color: $navigation-toolbar-sub-bg-color;
    overflow: auto;
    transition-property: height;
    transition-duration: 400ms;
    transition-timing-function: ease;
    transition-delay: 0s;

    .#{$prefix}toolbar-sub-inner {
      position: relative;
      width: 100%;
      max-width: 1216px;
      margin: 0px auto 0px auto;
      padding-top: 32px;
      padding-right: 24px;
      padding-bottom: 32px;
      padding-left: 24px;

      @include for-size(desktop-or-smaller) {
        max-width: 1200px;
      }

      @include for-size(desktop) {
        padding-right: 16px;
        padding-left: 16px;
      }

      @include for-size(tablet) {
        padding-left: 4px;
        padding-right: 4px;
      }

      @include for-size(phone) {
        padding-left: 8px;
        padding-right: 8px;
      }
    }
  }

  .#{$prefix}main-sub-wrapper {
    position: absolute;
    left: 0;
    width: 100%;
    height: 0;
    overflow: hidden;
    z-index: 99;

    .#{$prefix}main-sub {
      position: absolute;
      left: 0;
      top: 0;
      transform: translateY(-110%);
      transform-origin: top;
      width: 100%;
      height: auto;
      max-height: 70vh;
      background-color: $navigation-main-sub-bg-color;
      overflow: auto;
      box-shadow: $navigation-main-sub-box-shadow;
      transition-property: all;
      transition-duration: 400ms;
      transition-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
      transition-delay: 0s;

      &.#{$prefix}active {
        transform: translateY(0px);
        transition-duration: 800ms;
        transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);
      }

      .#{$prefix}main-sub-inner {
        position: relative;
        width: 100%;
        max-width: 1216px;
        margin: 0px auto 0px auto;
        padding-top: 32px;
        padding-right: 24px;
        padding-bottom: 32px;
        padding-left: 24px;

        @include for-size(desktop-or-smaller) {
          max-width: 1200px;
        }

        @include for-size(desktop) {
          padding-right: 16px;
          padding-left: 16px;
        }

        @include for-size(tablet) {
          padding-right: 4px;
          padding-left: 4px;
        }

        @include for-size(phone) {
          padding-right: 8px;
          padding-left: 8px;
        }
      }
    }
  }

  .#{$prefix}overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 20;
    background-color: rgba(57, 57, 58, 0.4);
    visibility: hidden;
    opacity: 0;
    transition-property: all;
    transition-duration: 400ms;
    transition-timing-function: ease;
    transition-delay: 0s;

    &.#{$prefix}act {
      visibility: visible;
      opacity: 1;
    }
  }
}

.#{$prefix}mobile-wrapper {
  position: absolute;
  left: -400px;
  width: $mobile-nav-width;
  height: calc(100vh - var(--mobileNavigationPadding));
  background-color: $navigation-mobile-bg-color;
  z-index: 30;
  overflow: hidden;
  font-family: $font-family-base;
  display: none;
  box-sizing: border-box;

  &.from-left {
    left: -400px;
    right: unset;
  }

  &.from-right {
    right: -400px;
    left: unset;
  }

  transition-property: left, right;
  transition-duration: 400ms;
  transition-timing-function: cubic-bezier(0.47, 0, 0.745, 0.715);
  transition-delay: 0s;

  &.act {
    transition-duration: 800ms;
    transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1);

    &.from-left {
      left: 0;
    }

    &.from-right {
      right: 0;
    }
  }

  @include for-size(phone) {
    display: block;
    width: $mobile-nav-width-phone;
  }

  @include for-size(tablet) {
    display: block;
  }
}

.mobile-main-nav {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background-color: $navigation-mobile-bg-color;

  transition-property: filter;
  transition-duration: 500ms;
  transition-timing-function: ease;
  transition-delay: 0s;

  .mobile-main-nav-inner {
    position: relative;
    padding: 24px 0px 140px 0px;
    transition-property: transform;
    transition-duration: 500ms;
    transition-timing-function: ease;
    transition-delay: 0s;

    .main-navigation-links {
      position: relative;
      margin-bottom: 46px;
    }

    .toolbar-navigation-links {
      position: relative;
    }
  }

  &.scale {
    filter: brightness(80%);

    .mobile-main-nav-inner {
      transform: scale(0.93);
    }
  }
}

.mobile-secondary-nav {
  position: absolute;
  right: -305px;
  top: 0;
  width: 100%;
  height: 100%;
  box-shadow: -1px 0px 0px 0px #{$navigation-mobile-bg-color};
  overflow: hidden;
  overflow-y: auto;
  background-color: $navigation-mobile-bg-color;
  display: flex;
  flex-direction: column;

  transition-property: right;
  transition-duration: 500ms;
  transition-timing-function: ease;
  transition-delay: 0s;

  &.no-animation {
    transition: unset;
  }

  &.act {
    right: 0;
  }

  .mobile-secondary-nav-backlink {
    position: relative;
    cursor: pointer;
    font-size: 24px;
    padding: 12px 24px 12px 64px;
    margin: 8px 0px 8px 0px;
    line-height: 24px;
    font-weight: 700;
    color: #{$navigation-mobile-link-font-color};

    @include for-size(phone) {
      font-size: 22px;
      line-height: 22px;
      padding-left: 56px;
    }

    eon-ui-icon {
      position: absolute;
      left: 34px;
      top: 50%;
      transform: translateY(-50%);
      color: #{$navigation-mobile-link-font-color};

      @include for-size(phone) {
        left: 26px;
      }
    }
  }

  .mobile-secondary-nav-inner {
    position: relative;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding-bottom: 140px;

    &.spacing {
      padding-left: 8px;
      padding-right: 8px;
    }

    &.spacing-top {
      padding-top: 24px;
    }
  }

  eon-ui-navigation-flyout-divider {
    display: none;
  }
}

::slotted(eon-ui-navigation-toolbar) {
  @include for-size(tablet-or-smaller) {
    display: none;
  }
}
